<template>
  <div v-if="project !== undefined">
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='project'
            :project='project'
            @update='update'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <irrigation-details
            v-if='project'
            :project='project'
            @update='update'
          ></irrigation-details>
        </v-col>
        <v-col cols='12' md='4'>
          <mechanical
            v-if='project'
            :project='project'
            @update='update'
          ></mechanical>
        </v-col>
        <v-col cols='12' md='4'>
          <contacts
            v-if='project'
            :project='project'
            @update='update'
          ></contacts>
        </v-col>
        <v-col cols='12' md='4'>
          <stickies
            v-if='project'
            :project='project'
          ></stickies>
        </v-col>
      </v-row>
      <template v-if='project && project.install_form && project.install_form.form_submitted'>
      <wc-page-section class='mt-n7' title='Install Form'></wc-page-section>
      <v-row>
        <v-col cols='12' md='12'>
          <wc-data-box
              :title='Install'
              titleIcon='mdi-paperclip'
              titleIconColor='green'
              :showAdd='false'
              :loading='loading'
            >
    <v-container>
      <div style='padding-left: 20px; padding-right: 20px;'>
        <v-row>
          <v-col cols='6'>
            <p>Completed by: {{project.install_form.asbuilt_completed_by}}</p>
          </v-col>
          <v-col cols='6'>
          </v-col>
          <v-col cols='3'>
            <p># of 1802s: {{project.install_form.num_1802}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 1812s: {{project.install_form.num_1812}}</p>
          </v-col>
          <v-col cols='2'></v-col>
          <v-col cols='4'>
            <p># of Shrubrisers: {{project.install_form.num_shrubrisers}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 1804s: {{project.install_form.num_1804}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 1804 SAMs: {{project.install_form.num_1804_SAM}}</p>
          </v-col>
          <v-col cols='2'></v-col>
          <v-col cols='4'>
            <p># of Shrubblers: {{project.install_form.num_shrubblers}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 3504s: {{project.install_form.num_3504}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 3504 SAMs: {{project.install_form.num_3504_SAM}}</p>
          </v-col>
          <v-col cols='2'></v-col>
          <v-col cols='4'>
            <p># Xeris: {{project.install_form.num_xeris}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 5004s: {{project.install_form.num_5004}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 5004 SAMs: {{project.install_form.num_5004_SAM}}</p>
          </v-col>
          <v-col cols='2'></v-col>
          <v-col cols='4'>
            <p># Zones: {{project.install_form.num_zones}}</p>
          </v-col>
          <v-col cols='3'>
            <p># of 5012s: {{project.install_form.num_5012}}</p>
          </v-col>
          <v-col cols='9'></v-col>
          <v-col cols='3'>
            <p>1/4" tubing(feet): {{project.install_form.quarter_tubing}}</p>
          </v-col>
          <v-col cols='4'>
            <p>3/4" poly(# of rolls): {{project.install_form.three_quarter_poly}}</p>
          </v-col>
          <v-col cols='4'>
            <p>1" poly(# of rolls): {{project.install_form.one_inch_poly}}</p>
          </v-col>
          <v-col cols='3'>
            <p>System supplied by a hosebib: {{project.install_form.sys_supply_hosebib ? "Yes" : "No"}}</p>
          </v-col>
          <v-col cols='3'>
            <p>Charged line to a hosebib: {{project.install_form.charged_line_to_hosebib ? "Yes" : "No"}}</p>
          </v-col>
          <v-col cols='6'></v-col>
          <v-col cols='3'>
            <p>Charged line to water feature: {{project.install_form.charged_line_to_water ? "Yes" : "No"}}</p>
          </v-col>
          <v-col cols='3'>
            <p>Labeled rain sensor location: {{project.install_form.labelled_rain_sensor_location ? "Yes" : "No"}}</p>
          </v-col>
          <v-col cols='6'></v-col>
          <v-col cols='6'>
            <p>Is there anything special to do at startup: {{project.install_form.special_startup_required ? "Yes" : "No"}}</p>
          </v-col>
          <v-col cols='6'></v-col>
          <v-col cols='12' v-if='project.install_form.special_startup_required'>
            <p>Special SU Instructions:</p>
            <p>{{project.install_form.special_startup_description}}</p>
          </v-col>
          <v-col cols='6'>
            <p>Is there anything special to do at blowdown: {{project.install_form.special_blowdown_required ? "Yes" : "No"}}</p>
          </v-col>
          <v-col cols='6'></v-col>
          <v-col cols='12' v-if='project.install_form.special_blowdown_required'>
            <p>Special BD Instructions:</p>
            <p>{{project.install_form.special_blowdown_description}}</p>
          </v-col>
          <v-col cols='12'>
            <p>Where is the controller located: {{project.install_form.controller_location}}</p>
          </v-col>
          <v-col cols='6'>
            <p>Is this commercial: {{project.install_form.is_commercial ? "Yes" : "No"}}</p>
          </v-col>
          <v-col cols='6'></v-col>
          <v-col cols='12' v-if='project.install_form.is_commercial'>
            <p>Where is the shutoff located:</p>
            <p>{{project.install_form.shutoff_location}}</p>
          </v-col>
        </v-row>
      </div>
    </v-container>
            </wc-data-box>
        </v-col>
      </v-row>
      </template>
      <wc-page-section class='mt-n7' title='Files'></wc-page-section>
      <v-row>
        <v-col cols='12' md='12'>
          <project-files
            v-if='project'
            :files='project.project_file_data'
            :project_id='project.id'
            :disabled='project.archived'
          ></project-files>
        </v-col>
      </v-row>
      <wc-page-section class='mt-n10' title='SUBD'></wc-page-section>
      <v-row>
         <v-col cols='12' md='4'>
          <authorizations
            v-if='project'
            :project='project'
            @update='update'
          ></authorizations>
        </v-col>
        <v-col cols='12' md='4'>
          <outstanding-service
            v-if='project'
            :project='project'
            :disableAdd='project.archived'
            allowEdits
            showHelp
          ></outstanding-service>
        </v-col>
        <v-col cols='12' md='4'>
          <subd-tier
            v-if='project'
            :project='project'
            @update='update'
          ></subd-tier>
        </v-col>
        <v-col cols='12' md='4'>
          <!-- notes on using the below three boxes.  second and third must be fields on the detail, first must be on the project -->
          <tproject.install_form.part-data-box
            v-if='project'
            :project='project'
            title='Permanent Office'
            first-label='General Office Instructions'
            first-part='office_instructions'
            second-label='Startup-specific Office Instructions'
            second-part='su_instr_perm_office'
            third-label='Blowdown-specific Office Instructions'
            third-part='bd_instr_perm_office'
            @update='updateSpecial'
            showHelp
            helpText='General office instructions will appear on all project.install_form.k orders created for this project<br><br>Specific BD and SU instructions will only appear work orders of those types.<br><br>There is no need to duplicate information.<br>(A StartUp Work Order will show BOTH the General Instructions AND the Startup-specific Instructions.'
          ></tproject.install_form.part-data-box>
        </v-col>
        <v-col cols='12' md='4'>
          <tproject.install_form.part-data-box
            v-if='project'
            :project='project'
            title='Permanent Client'
            second-label='Startup-specific Client Instructions'
            second-part='su_instr_perm_client'
            third-label='Blowdown-specific Client Instructions'
            third-part='bd_instr_perm_client'
            @update='update'
            showHelp
            helpText='These are added into emails to the client if they have requested any additional instructions'
          ></tproject.install_form.part-data-box>
        </v-col>
        <v-col cols='12' md='4'>
          <tproject.install_form.part-data-box
            v-if='project'
            :project='project'
            title='Permanent Field'
            first-label='General Field Instructions'
            first-part='field_instructions'
            second-label='Startup-specific Field Instructions'
            second-part='su_instr_perm_field'
            third-label='Blowdown-specific Field Instructions'
            third-part='bd_instr_perm_field'
            @update='update'
            showHelp
            helpText='General Instructions will appear on any project.install_form.k order created for this project<br><br>Specific BD and SU instructions will only appear work orders of those types.<br><br>There is no need to duplicate information.<br>(A StartUp Work Order will show BOTH the General Instructions AND the Startup-specific Instructions)'
          ></tproject.install_form.part-data-box>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4'>
          <wc-data-box
            title="Scheduling Considerations"
            :showEdit='false'
            :showHelp='false'
            helpText=''
          >
            <div class='px-4' style="font-size: 12px; padding-top: 10px; display: flex; flex-direction: column; width: 100%;">
              <v-checkbox 
                dense
                class='my-checkbox'
                color="blue"
                label="Startup Call or Email Ahead"
                v-model='project.call_ahead'
                @change='updateSchedulingConsiderations($event, "call_ahead")'
              />
              <v-checkbox 
                dense
                class='my-checkbox'
                color="blue"
                label="Blowdown Call or Email Ahead"
                v-model='project.bd_call_ahead'
                @change='updateSchedulingConsiderations($event, "bd_call_ahead")'
              />
            </div>
          </wc-data-box>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='6'>
          <one-time-notes
            v-if='project'
            title='One Time SU Notes'
            :isSUNote='true'
            :project='project'
            :notes='suNotes'
            :isLoading='loadingNotes'
            @updateSpecial='updateSpecial'
          ></one-time-notes>
        </v-col>
        <v-col cols='12' md='6'>
          <one-time-notes
            v-if='project'
            :isSUNote='false'
            title='One Time BD Notes'
            :project='project'
            :isLoading='loadingNotes'
            :notes='bdNotes'
            @updateSpecial='updateSpecial'
          ></one-time-notes>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from '@/modules/projects/components/Basics';
import Contacts from '@/modules/projects/components/Contacts';
import ProjectFiles from '@/components/files/ProjectFiles';
import Details from '@/modules/irrigation/components/Details';
import Mechanical from '@/modules/irrigation/components/Mechanical';
import irrigationAPI from '@/modules/irrigation/api/irrigations';
import OutstandingService from '@/modules/projects/components/OutstandingService';
import Stickies from '@/modules/projects/components/Stickies';
import Authorizations from '@/modules/irrigation/components/subd/Authorizations';
import SUBDTier from '@/modules/irrigation/components/subd/SUBDTier';
import TwoPartDataBox from '@/modules/irrigation/components/subd/TwoPartDataBox';
import OneTimeNotes from '@/modules/irrigation/components/subd/OneTimeNotes';
import projectAPI from '@/api/project';

export default {
  name: 'irrigation-overview',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    notes: [],
    suNotes: [],
    bdNotes: [],
    loadingNotes: true,
    show_scheduling_considerations: false
  }),
  mounted () {
    this.getNotes()
    console.log(this.project)
  },
  methods: {
    update (proj) {
      this.$emit('update', proj)
    },
    async updateDetail (proj) {
      await irrigationAPI.updateIrrigationProject(proj)
    },
    async updateSpecial (proj) {
      this.$emit('updateSpecial', proj)
    },
    async getNotes () {
      this.notes = await irrigationAPI.getOneTimeNotes(this.project.id)
      this.suNotes = this.notes.filter(a => a.is_su_note === true)
      this.bdNotes = this.notes.filter(a => a.is_su_note !== true)
      this.loadingNotes = false
    },
    async updateSchedulingConsiderations(event, option){
      const update_values = {}

      if(option === "call_ahead"){
        update_values.call_ahead = event;
      }
      else if(option === "bd_call_ahead"){
        update_values.bd_call_ahead = event;
      }
      projectAPI.updateProject(this.project.id, update_values);
    }
  },
  components: {
    'basics': Basics,
    'contacts': Contacts,
    'mechanical': Mechanical,
    'project-files': ProjectFiles,
    'irrigation-details': Details,
    'outstanding-service': OutstandingService,
    'stickies': Stickies,
    'authorizations': Authorizations,
    'tproject.install_form.part-data-box': TwoPartDataBox,
    'one-time-notes': OneTimeNotes,
    'subd-tier': SUBDTier
  }
}
</script>
<style scoped>
  .my-checkbox .v-label {
    font-size: 12px;
  } 
  ::v-deep .my-checkbox .v-label {
  font-size: 12px;
  }
</style>
